// extracted by mini-css-extract-plugin
export default {"loadingInner":"styles_loadingInner__5nJS-","buttonLoadingAnimation":"styles_buttonLoadingAnimation__tnak+","wrapper":"styles_wrapper__a4rFQ"};